import { combineReducers, createReducer, on } from '@ngrx/store';
import { ConfigurationsSubState, initialConfigurationsSubState } from '../genesys-cloud-web-deployments.state';
import * as ConfigurationActions from '../actions/configuration.actions';
import { configurationEntityAdapter } from '../adapters/configuration.adapter';

const configurationsReducer = createReducer(
  initialConfigurationsSubState(),
  on(
    ConfigurationActions.configurationChanged,
    (state, { configuration }): ConfigurationsSubState => configurationEntityAdapter.setOne(configuration, state)
  )
);

export const genesysCloudWebDeploymetsReducer = combineReducers({
  configurations: configurationsReducer
});
